export enum VehicleLayoutType {

    MINIBUS = 'minibus',
    SHORT_BUS = 'short_bus',
    LONG_BUS = 'long_bus',
    SHORT_TRAM = 'short_tram',
    MEDIUM_TRAM = 'medium_tram',
    LONG_TRAM = 'long_tram'
}
